import {
  Box,
  ListItem,
  ListItemButton,
  SvgIconOwnProps,
  Typography,
} from '@mui/material';
import NextLink from '@/components/link/NextLink';
import { getOfficialAnnouncementInfo } from '@/types/officialAnnouncement';
import { Information } from 'mdi-material-ui';

const IconProps: SvgIconOwnProps = {
  sx: {
    fontSize: '32px',
    color: '#C4C4C4',
  },
};

const InformationIcon = () => <Information {...IconProps} />;

type Props = {
  officialAnnouncementInfo: ReturnType<typeof getOfficialAnnouncementInfo>;
};

export function OfficialAnnouncementListItem({
  officialAnnouncementInfo,
}: Props) {
  if (!officialAnnouncementInfo || !officialAnnouncementInfo.value.title)
    return null;

  return (
    <ListItem
      sx={{
        display: 'flex',
        padding: '0',
        borderBottom: '1px solid #E9E9E9',

        ' a': {
          width: '100%',
          textDecoration: 'none',
          color: 'initial',
        },

        '&:last-child': {
          borderBottom: 'none',
        },
      }}
    >
      <ListItemButton
        LinkComponent={NextLink}
        sx={{
          alignItems: 'start',
          padding: '16px 0',
        }}
        href={officialAnnouncementInfo.value.url}
      >
        <Box>
          <InformationIcon />
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            paddingLeft: '8px',
          }}
        >
          <Typography variant="JP/Body/m/Regular/Tight" color="text.secondary">
            {officialAnnouncementInfo.value.title}
          </Typography>

          {officialAnnouncementInfo.text.displayStartAtText && (
            <Typography
              variant="JP/Body/s/Regular/Tight"
              sx={{
                color: '#C4C4C4',
              }}
            >
              {officialAnnouncementInfo.text.displayStartAtText}
            </Typography>
          )}
        </Box>
      </ListItemButton>
    </ListItem>
  );
}
